import { action } from '@ember/object';
import { service } from '@ember/service';
import FastbootHelpersMixin from 'client-portal/mixins/route/fastboot-helpers';
import Route from '@ember/routing/route';
import classic from 'ember-classic-decorator';

@classic
export default class NotFoundRoute extends Route.extend(FastbootHelpersMixin) {
  @service localeManager;
  @service session;

  async afterModel(_model) {
    super.afterModel(...arguments);
    await this.localeManager.initializeLocale();
  }

  @action
  didTransition() {
    if (this.isFastBoot) {
      this.set('fastboot.response.statusCode', 404);

      // A signed-in users's 404 looks generic but isn't. Prevent caching. For anonymous however
      // strip set-cookie headers rails injects via client-portal-api
      if (this.session.currentClientAccess || this.session.currentClient) {
        this.fastboot.response.headers.set('cache-control', 'private, no-store');
      } else {
        this.fastboot.response.headers.delete('set-cookie');
      }
    }
  }
}
